import React from "react";
import { motion } from "framer-motion";
import { useGoTo } from "../nav";
import { useLang } from "../i18n";
import real4 from "../assets/real-4.jpg";
import { Cloud, Flower, Sparkle } from "./decor";

export default function JoinCta() {
  const goTo = useGoTo();
  const { s } = useLang();
  return (
    <section id="join" data-testid="join-section" className="relative py-20 sm:py-24 overflow-hidden">
      <Cloud className="absolute left-[5%] top-12 w-24 opacity-80 animate-drift" />
      <Sparkle className="absolute right-[8%] top-14 w-8 hidden md:block" color="#E08D75" />
      <Flower className="absolute right-[14%] bottom-12 w-9 animate-sway" petal="#F0A28C" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="relative w-72 h-72 sm:w-96 sm:h-96 mx-auto"
          style={{ background: "#B5C4A8", borderRadius: "46% 54% 55% 45% / 55% 48% 52% 45%" }}
        >
          <img
            data-testid="join-photo"
            src={real4}
            alt="Circle Time Center with learning posters and toys"
            className="absolute inset-6 w-[calc(100%-3rem)] h-[calc(100%-3rem)] sm:inset-9 sm:w-[calc(100%-4.5rem)] sm:h-[calc(100%-4.5rem)] object-cover rounded-full"
          />
        </motion.div>

        <div className="text-center lg:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight"
          >
            <span className="text-sageBlue">{s.join.h1}</span>
            <span className="text-coral">{s.join.h2}</span>
          </motion.h2>
          <p className="font-display font-semibold text-forest text-lg sm:text-xl mt-6">{s.join.bold}</p>
          <p className="text-forest/80 text-base sm:text-lg leading-relaxed mt-4">{s.join.p}</p>
          <a
            data-testid="join-enroll-button"
            href="/contact"
            onClick={(e) => {
              e.preventDefault();
              goTo("/contact");
            }}
            className="inline-flex mt-8 rounded-full bg-cardTan text-white font-display font-semibold tracking-wide uppercase text-base px-10 py-4 shadow-card hover:bg-coral hover:scale-[1.03] transition-all duration-200"
          >
            {s.join.cta}
          </a>
        </div>
      </div>
    </section>
  );
}
